import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4tjuquvbn: FaireProductEntity = {
  token: "p_v4tjuquvbn",
  type: "product",
  name: "The Stockholm Scarf - 100% Recycled - The Arctic - FW25",
  brandToken: "b_3mgp73jmn6",
  brandName: "Arctic Fox & Co. - North America",
  imageUrl:
    "https://cdn.faire.com/fastly/36475abd2dbd5323e4c8f85da829b6a29b7ed0b2ec814a0aa8c634c5f789ebcd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d71a527b5d33f211427a1f8934fdd9e9226d282735df14d91f52dfb18ff4530.jpeg",
    "https://cdn.faire.com/fastly/2f65755f56e2179f8c0574ea01e368286f13980f7763c38442e4db80e0eb81ab.jpeg",
    "https://cdn.faire.com/fastly/3d115a1af35ce98eeee75b2c16adf89aaf967eecd8ac6d88fe5e8dbeedfb390f.jpeg",
    "https://cdn.faire.com/fastly/1a8f31246f7597725c2ac96b67c3a6d3d5b980d4f6d12403a2ba3ac598363a1f.jpeg",
    "https://cdn.faire.com/fastly/9ee6ff1b85975e6cbd690e69046c53d0bab87c9bc198d282464f137767d7e611.jpeg",
    "https://cdn.faire.com/fastly/3fbb92a73c8d800560ee25f67895bd45608c2f7bb5c2704faca80a55561b2ca6.jpeg",
    "https://cdn.faire.com/fastly/a0d56b3915c0c44119d646de90bec4b2249916b2f2e571e3110721f8355b787d.jpeg",
    "https://cdn.faire.com/fastly/a20fe256e0c50e42469def5bcea0290e55e367d30d39baeb80b88e57aba6c8a8.jpeg",
    "https://cdn.faire.com/fastly/6ef1ed2e78233cdde274aa06fcbb74672bdf5b07e4dc42c89ea32917a4cc40cf.jpeg",
  ],
  priceDollars: 17.58,
  description:
    "One of our best-selling styles. \nShowcasing the addictive super-soft brushed texture we’re known for, the Stockholm scarf is made from 100% recycled materials. \n\nUpdated this AW25/26 with fresh, on-trend new season shades that perfectly complement our timeless CORE best-selling check designs, named and inspired by nature’s beautiful ever-changing landscape from season to season.\n\nThe technical bits: \n\t•\tMade from 100% recycled materials (we are very proud to be one of the first brands using recycled acrylic achieved in collaboration with our supplier).\n\t•\tConstruction and brush cycles on the machines engineered to minimize any potential pilling. \n\t•\tBrushed an extensive six times compared to the industry standard of four, the result is a thicker, warmer, ‘fluffier’ texture. \n\nPlastic free packaging: arrives in our new 100% paper protective bags.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:56.580Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
